export default {
    configuration_hubspot_title: "Configure HotSpot",
    configuration_hubspot_enable: "Enable",
    configuration_hubspot_disable: "Disable",
    configuration_hubspot: "HotSpot",
    configuration_hubspot_message: "* This parameter allow to enable/disable NAT function in the camera",
    configuration_hubspot_cycle_begin_day: "Cycle Begin Day",
    configuration_hubspot_cycle_begin_day_message: "on this day the monthly consumption restarts",
    configuration_hubspot_max_monthly_usage: "Max Monthly Usage In MB",
    configuration_hubspot_max_monthly_usage_message: "Maximum data consumption in MB allowed in the cycle of the month",
    configuration_hubspot_day: "day(s)",
    configuration_hubspot_mb: "MB",

    configuration_hubspot_all_events: "All Events",
    configuration_hubspot_group_events: "Group of Events",
    configuration_hubspot_specific_events: "Specific Events",
    configuration_hubspot_all_accel_events: "All Acceleration Events",
    configuration_hubspot_all_dms_events: "All DMS Events",
    configuration_hubspot_all_adas_events: "All ADAS Events",
    configuration_hubspot_events: "Events",
    configuration_hubspot_accel_events: "Acceleration Events",
    configuration_hubspot_dms_events: "DMS Events",
    configuration_hubspot_adas_events: "ADAS Events",
    configuration_hubspot_others_events: "Others Events",
    
    configuration_hubspot_severe_brake: "Severe Brake",
    configuration_hubspot_hard_brake: "Hard Brake",
    configuration_hubspot_harsh_brake: "Harsh Brake",
    configuration_hubspot_harsh_accel: "Harsh Accel",
    configuration_hubspot_harsh_turn: "Harsh Turn",
    configuration_hubspot_sharp_turn: "Sharp Turn",
    configuration_hubspot_severe_turn: "Severe Turn",
    configuration_hubspot_driving_hit: "Driving Hit",
    configuration_hubspot_severe_accel: "Severe Accel",
    configuration_hubspot_driving_heavy_hit: "Driving Heavy Hit",
    configuration_hubspot_hard_accel: "Hard Accel",

    configuration_hubspot_using_phone: "Using Phone",
    configuration_hubspot_smoking: "Smoking",
    configuration_hubspot_drowsiness: "Drowsiness",
    configuration_hubspot_no_seatbelt: "No Seatbelt",
    configuration_hubspot_no_driver: "No Driver",
    configuration_hubspot_daydreaming: "Daydreaming",
    configuration_hubspot_yawn: "Yawn",
    configuration_hubspot_asleep: "Asleep",
    configuration_hubspot_distracted: "Distracted",

    configuration_hubspot_forward_collision_warning: "Forward Collision Warning",
    configuration_hubspot_headway_monitoring_warning: "Headway Monitoring Warning",
    configuration_hubspot_headway_monitoring_emergency: "Headway Monitoring Emergency",
    configuration_hubspot_lane_departure_warning: "Lane Departure Warning",

    configuration_hubspot_manual: "Manual",

    configuration_hubspot_save_title: "Save configuration upload mode",
    configuration_hubspot_save_success: "Configuration upload mode saved",
    configuration_hubspot_save_error: "Configuration upload mode save error",

    configuration_hubspot_next: "Next",
    configuration_hubspot_back: "Back",
    configuration_hubspot_apply: "Apply",
    configuration_hubspot_potential_incident_low: "Potential Incident Low",
    configuration_hubspot_potential_incident_medium: "Potential Incident Medium",
    configuration_hubspot_potential_incident_high: "Potential Incident High",
    configuration_hubspot_driving_suspicious_hit: "Driving Suspicious Hit",
    configuration_hubspot_idle_no_driver: "Idle No Driver",
    configuration_hubspot_power_lost: "Power Lost",
    configuration_hubspot_500mb: "500 MB",
    configuration_hubspot_1gb: "1 GB"
}